<template>
  <header id="header">
    <TopAppBar />
    <NavDrawer />
  </header>
</template>

<script>
import NavDrawer from "@/components/header/NavDrawer.vue";
import TopAppBar from "@/components/header/TopAppBar.vue";

export default {
  name: 'Header',
  components: {
    NavDrawer,
    TopAppBar,
  },
  mounted() {
  },
  computed: {
  }
}
</script>

<style lang="scss">
// Global > Header
#app-bar {
	background-color: #2e1511;
}

.arrow svg path {
	fill: #fff;
}
svg {
	&.msg path,
	&.search circle,
	&.search path,
	&.cart circle,
	&.cart path {
		stroke: #fff;
	}
}
</style>
